/**
 * Model configuration
 */
export const config = {
  modelName: 'check-eligibility',
  formName: 'check-eligibility'
} as const;
